/**
 * Quick-poll localStorage helpers.
 *
 * Shared between QuickPollBlock (renders + writes) and BlockLoader request
 * augmentation (reads). Extracted so the request layer can prime the API
 * with already-answered question IDs before the block component mounts —
 * otherwise BlockLoader renders a collapsed preview for a question that
 * the user has already answered, and expanding it shows an empty body.
 */

const STORAGE_KEY_PREFIX = 'quickpoll_answered_';

export function getStorageKey(clientId, memberId) {
  if (memberId) {
    return `${STORAGE_KEY_PREFIX}${clientId}_${memberId}`;
  }
  return `${STORAGE_KEY_PREFIX}${clientId}`;
}

export function getAnsweredFromStorage(storageKey) {
  try {
    return JSON.parse(localStorage.getItem(storageKey) || '[]');
  } catch {
    return [];
  }
}

export function saveAnsweredToStorage(storageKey, questionId) {
  try {
    const answeredIds = getAnsweredFromStorage(storageKey);
    if (!answeredIds.includes(questionId)) {
      answeredIds.push(questionId);
      localStorage.setItem(storageKey, JSON.stringify(answeredIds));
    }
  } catch {
    // Ignore localStorage errors
  }
}
